module.exports = __webpack_public_path__ + "static/media/brainRocket.b117c65c.jpg";